// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"833":"6c70bf5a","839":"bcd01d1c"}[chunkId] + ".chunk.js";
};